import React, { Component } from "react";
import { ErrorNotification, MnemoLoading, Title } from "components/misc";
import { MSelect } from "components/forms";
import { Button, Row, Col, Icon } from "design-react-kit";
import { CourseHelper, lessonSectionService, stringHelper } from "libs";
import { ROUTES } from "const";

export class LessonScheduleProcessTFAClassico extends Component {
  studentsToExport = [];
  sectionABSkip = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

  state = {
    loading: false,
    loadingError: "",
    courseCode: "",
    academicYear: 0,
    students: [],
    sections: [],
  };

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2025/2026", value: 2025 },
    ],
  };

  // SAVERIO: decidere cosa fare
  COURSECODES_2025 = [
    { label: "SELEZIONA UN CORSO", value: "" },
    { label: "TFA Cefalù", value: "TFAPA" },
    { label: "TFA Venezia", value: "TFAVE" },
  ];

  PAYLOAD_COURSECODE = {
    2025: {
      options: this.COURSECODES_2025,
    },
  };

  setAcademicYear = (_, value) => {
    const courseCode = "";
    this.setState({ academicYear: value, courseCode });
  };

  setCourseCode = (_, value) => {
    this.setState({ courseCode: value });
  };

  loadStudents = () => {
    this.setState({ loading: true, loadingError: "" });
    const { courseCode, academicYear } = this.state;

    if (courseCode === "") {
      ErrorNotification.render("Devi specificare un corso per poter procedere");
      this.setState({ loading: false });
    } else {
      lessonSectionService
        .listAnalyticsStudentsTFAClassico(academicYear, courseCode)
        .then(({ data }) => {
          const { students, sections } = data.payload;
          this.setState({ students, sections, loading: false });
        })
        .catch((error) => {
          console.error("Error ", error);
          ErrorNotification.render("Errore  server");
          this.setState({ loading: false, loadingError: error });
        });
    }
  };

  analyzeStudents = (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }

    this.setState({ loading: true, loadingError: "" });
    const { students, courseCode, academicYear } = this.state;

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      if (courseCode.length === 0 || academicYear === 0) {
        ErrorNotification.render("Dati inconsistenti. Ricarica l'elenco degli studenti tramite il pulsante 'Elenco studenti'");
        this.setState({ loading: false });
      } else {
        lessonSectionService
          .analizeAnalyticsStudentsTFAClassico(academicYear, courseCode)
          .then(({ data }) => {
            this.loadStudents();
            this.setState({ loading: false });
          })
          .catch((error) => {
            console.error("Error ", error);
            ErrorNotification.render("Errore  server");
            this.setState({ loading: false, loadingError: error });
          });
      }
    }
  };

  goToAnalyticsDetail = (student) => {
    window.location.href = `${ROUTES.LESSON_STUDENT_ANALYTICS}/${student.registrationCode}`;
  };

  exportStudents = () => {
    const students = this.studentsToExport;

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      const sections = this.state.sections;
      let str = "CODICE REGISTRAZIONE;COGNOME;NOME;EMAIL;TELEFONO;CODICE CORSO;TIPOLOGIA PERCORSO;";

      for (let j = 0; j < sections.length; j++) {
        str += `SEZIONE;MINUTI MATURATI;MINUTI TOTALI;PERCENTUALE ATTUALE;`;
      }
      str += "\r\n";

      for (let i = 0; i < students.length; i++) {
        const student = students[i];
        let addRow = `${student.registrationCode};${student.surname};${student.name};${student.email};${student.mobile};${student.courseCode};`;
        addRow += CourseHelper.isTFAAbbreviato(student.courseCode) ? "ABBREVIATO;" : "REGOLARE;";

        for (let j = 0; j < sections.length; j++) {
          const section = sections[j];
          const sectionTitle = (section.code || "") + " " + (section.title || "");

          addRow += `${sectionTitle};${student[section.code + "M"] || ""};${student[section.code + "T"] || ""};${student[section.code + "P"] || ""};`;
        }
        str += addRow + "\r\n";
      }

      // calcolo il nome della edizione selezionata

      let downloadLink = document.createElement("a");
      downloadLink.href = "data:text/csv;charset=utf-8," + encodeURIComponent(str);
      downloadLink.download = "corsisti_frequenza_" + this.state.academicYear + "_" + this.state.courseCode + ".csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  renderStudents() {
    const { students, sections } = this.state;

    let prevStudent = {};
    let currentSections = [...sections];
    let currentSection = {};
    let studentToExport = {};
    let rows = [];
    let position = 1;
    this.studentsToExport = [];

    for (let i = 0; i < students.length; i++) {
      const student = students[i];
      let show = false;

      if (prevStudent?.registrationCode === student.registrationCode) {
        show = false;
        if (!student.section) {
          continue;
        }
      } else {
        // aggiunge le sezioni mancanti nelle frequenze (tabelle *resume)
        if (prevStudent?.registrationCode && currentSections.length > 0) {
          for (let j = 0; j < currentSections.length; j++) {
            const section = currentSections[j];
            if (CourseHelper.isTFAAbbreviato(prevStudent.courseCode)) {
              // skip all sections of lessons
              if (this.sectionABSkip.includes(section.code)) {
                continue;
              }
            }

            rows.push(
              <tr key={j}>
                <td colSpan="7"> </td>
                <td>
                  {section.code}. {section.title}
                </td>
                <td>0/{section.totalMinutes}</td>
                <td>0%</td>
              </tr>,
            );

            studentToExport[section.code + "M"] = 0;
            studentToExport[section.code + "P"] = stringHelper.formatPercentage(0);
            studentToExport[section.code + "T"] = section.totalMinutes;
          }
        }

        if (prevStudent?.registrationCode) {
          studentToExport.registrationCode = prevStudent.registrationCode;
          studentToExport.surname = prevStudent.surname;
          studentToExport.name = prevStudent.name;
          studentToExport.email = prevStudent.email;
          studentToExport.mobile = prevStudent.mobile;
          studentToExport.courseCode = prevStudent.courseCode;
          this.studentsToExport.push(studentToExport);
        }

        prevStudent = student;
        show = true;
        currentSections = [...sections];
        currentSection = {};
        studentToExport = {};
      }

      if (student.section && currentSection?.code !== student.section) {
        // find the section by lessoncode  and remove it from currentSections
        currentSection = currentSections.find((s) => s.code.trim().toLowerCase() === student.section.trim().toLowerCase());

        if (currentSection) {
          // remove curentSection from currentSections array
          currentSections = currentSections.filter((s) => s.code.trim().toLowerCase() !== currentSection.code.trim().toLowerCase());
        } else {
          console.error("Section not found for student", student);
        }
      }

      const studentPercent = (student.minutes * 1.0) / currentSection.totalMinutes;

      rows.push(
        <tr key={i}>
          {show ? (
            <>
              <td>
                {position}
                <div className="mt-2 d-flex">
                  <span className="action icon-link" title="Dettaglio statistiche" onClick={() => this.goToAnalyticsDetail(student)}>
                    <Icon icon="it-file" color="primary" />
                  </span>
                </div>
              </td>
              <td>{student.registrationCode}</td>
              <td>{student.surname}</td>
              <td>{student.name}</td>
              <td>{student.email}</td>
              <td>{student.mobile}</td>
              <td>{student.courseCode}</td>
            </>
          ) : (
            <td colSpan="7"></td>
          )}
          <td>
            {student.section}. {currentSection.title}
          </td>
          <td>
            {student.minutes}/{currentSection.totalMinutes}
          </td>
          <td>{stringHelper.formatPercentage(studentPercent)}</td>
        </tr>,
      );

      if (show) position++;

      studentToExport[student.section + "M"] = student.minutes;
      studentToExport[student.section + "T"] = currentSection.totalMinutes;
      studentToExport[student.section + "P"] = stringHelper.formatPercentage(studentPercent);
    }

    // aggiunge le sezioni mancanti nelle frequenze (tabelle *resume)
    if (prevStudent?.registrationCode && currentSections.length > 0) {
      for (let j = 0; j < currentSections.length; j++) {
        const section = currentSections[j];

        // skip all sections of lessons
        if (CourseHelper.isTFAAbbreviato(prevStudent.courseCode)) {
          // skip all sections of lessons
          if (this.sectionABSkip.includes(section.code)) {
            console.log("skip section" + section.code);
            continue;
          }
        }

        rows.push(
          <tr key={j}>
            <td colSpan="7"></td>
            <td>
              {section.code}. {section.title}
            </td>
            <td>0/{section.totalMinutes}</td>
            <td>{stringHelper.formatPercentage(0)}</td>
          </tr>,
        );

        studentToExport[section.code + "M"] = 0;
        studentToExport[section.code + "T"] = currentSection.totalMinutes;
        studentToExport[section.code + "P"] = stringHelper.formatPercentage(0);
      }
    }

    studentToExport.registrationCode = prevStudent.registrationCode;
    studentToExport.surname = prevStudent.surname;
    studentToExport.name = prevStudent.name;
    studentToExport.email = prevStudent.email;
    studentToExport.mobile = prevStudent.mobile;
    studentToExport.courseCode = prevStudent.courseCode;
    this.studentsToExport.push(studentToExport);

    return (
      <>
        <h6>Studenti trovati: {this.studentsToExport.length}</h6>
        <table class="MTable table table-striped table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Codice registrazione</th>
              <th>Cognome</th>
              <th>Nome</th>
              <th>Email</th>
              <th>Telefono</th>
              <th>Codice corso</th>
              <th>Attività</th>
              <th>Minuti collegamento</th>
              <th>Frequenza di collegamento</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </>
    );
  }

  render() {
    const { loading, students, academicYear, courseCode } = this.state;

    return (
      <>
        {loading && <MnemoLoading />}
        <section className="m-4">
          <Title>Analisi frequenza corsi TFA Classico</Title>
          <Row>
            <Col md={12}>
              <MSelect onChange={this.setAcademicYear} id="academicYear" payload={this.PAYLOAD_YEAR}></MSelect>
            </Col>
          </Row>
          {academicYear > 0 && (
            <>
              <Row>
                <Col md={6}>
                  <MSelect
                    key={academicYear}
                    onChange={this.setCourseCode}
                    id="courseCode"
                    payload={this.PAYLOAD_COURSECODE[academicYear]}
                    value={courseCode}
                  ></MSelect>
                </Col>
              </Row>
            </>
          )}
          <Button
            color="primary bg-dark"
            onClick={() => {
              this.loadStudents();
            }}
          >
            <span className="d-button-label">Elenco studenti</span>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={(e) => {
              this.analyzeStudents(e);
            }}
          >
            <span className="d-button-label">Calcola tempo presenza</span>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={() => {
              this.exportStudents();
            }}
          >
            <span className="d-button-label">Esporta</span>
          </Button>
          <hr />
          {students.length > 0 && (
            <>
              <div>{this.renderStudents()}</div>
            </>
          )}
        </section>
      </>
    );
  }
}
